import { render, staticRenderFns } from "./ContainerDocumentsCategory.vue?vue&type=template&id=6817e352"
import script from "./ContainerDocumentsCategory.vue?vue&type=script&lang=js"
export * from "./ContainerDocumentsCategory.vue?vue&type=script&lang=js"
import style0 from "./ContainerDocumentsCategory.vue?vue&type=style&index=0&id=6817e352&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports